// Manage all the dynamics tests of the app
import { getQuery } from 'utils/common';
import Detect from 'helpers/Detect'
import Stage from 'helpers/Stage'
import Performance from 'helpers/Performance'

class Tests {
  constructor () {
  }

  get useFluid() {

    if (getQuery('noFluid')) return false;
    if (getQuery('useFluid')) return true;
    // if (Performance.tier === 0) return false; // no fluid for shitty device
    if (Detect.isMobile) return false; // no fluid for mobile
    return true;
  }

  get useFxVideo() {
    if (getQuery('useVideo')) return true;
    if (getQuery('noVideo')) return false;

    if (Detect.browserName === 'ie' || Detect.browserName === 'edge') {
      return false;
    }

    if (Performance.oldMBP) return false;

    let screenW = window.screen.availWidth;
    let screenH = window.screen.availHeight;
    let size = Math.max(screenW, screenH);
    if(Detect.os.name === 'ios') {
      if (Detect.isMobile && size < 800) return false // not iphone below iphone x size
      if (Detect.isMobile && size > 1000) return false // not ipad
    } else {
      if (Detect.isMobile && Performance.tier >= 2) return true // good android only
    }
    return true;
  }

  get useWebGL() {
    let href = document.location.href;
    href = href.toLowerCase();
    if (href.indexOf('nowebgl') > 0) {
      return false;
    }
    if (getQuery('noWebGl')) return false;
    if (getQuery('noWebGL')) return false;
    return true;
  }

  get glFPS() {
    return 60;
  }

  get DPR () {

    let w = window.innerWidth;

    if (Performance.tier === 0) {
      if(w > 1900) return .7
      else if (w > 1600) return .7
      else if (w > 1400) return .8
      else if (w > 1200) return .9
    }

    if (Performance.tier === 1) {
      if (w > 1600) return .9
      if (w > 1800) return .9
    }


    if (Performance.tier < 2 && window.innerWidth > 1930) {
      return .9;
    }

    return Math.min(window.devicePixelRatio || 1, 1)
  }

  get useSmoothScroll () {
    if (getQuery('smooth')) return true;
    if (getQuery('noSmooth') || getQuery('nosmooth')) return false; 
    // if (Detect.isMobile) return false;
    return true; // default
  }
}

export default new Tests()
